import {NgModule, Component, Input, ChangeDetectionStrategy, Inject} from '@angular/core';
import { APP_SETTINGS, DeviceInfo, DEVICE_INFO } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
	selector: 'two-column-view',
    template: `
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-md-push-8">
                    <ng-content select=":not([primary])"></ng-content>
                </div>
                <div class="col-md-7 col-md-pull-4" [class.phone]="isPhone">
                    <ng-content select="[primary]"></ng-content>
                </div>
            </div>
        </div>
    `,
    styles: [".phone{ position:static }"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TwoColumnView {
    public isPhone:boolean = false;
    constructor(
        @Inject(DEVICE_INFO) device: DeviceInfo
    )
    {
        this.isPhone = device.isPhone;
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/column-layout/two-column-view.component.ts